function FacebookIcon() {
    return (
        <svg
            id="ezQB74GlgsC1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 36 36"
            shapeRendering="geometricPrecision"
            textRendering="geometricPrecision"
            className="size-9"
        >
            <rect
                width="35.0842"
                height="35.0842"
                rx="17.5421"
                ry="17.5421"
                transform="translate(.457895 0.457895)"
                fill="#fff"
                stroke="#1f4464"
                strokeWidth="0.915789"
            />
            <path
                d="M21.7341,19.2582l.6064-3.8796h-3.7931v-2.5165c0-1.0617.5289-2.0971,2.2278-2.0971h1.7256v-3.30291c0,0-1.5654-.26214-3.0613-.26214-3.1253,0-5.1661,1.85854-5.1661,5.22175v2.9569h-3.4726v3.8796h3.4726v9.3792c.6972.1075,1.4104.1625,2.137.1625s1.4398-.055,2.137-.1625v-9.3792h3.1867Z"
                fill="#1f4464"
            />
        </svg>
    );
}

export default FacebookIcon;
